import { Image } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

type Props = {
  onResetDownloadUrl: () => Promise<string>;
};

export const DigitalContentThumbnail: React.FC<Props> = (props: Props) => {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  useEffect(() => {
    const handleReset = async () => {
      const url = await props.onResetDownloadUrl();
      setDownloadUrl(url);
    };
    if (downloadUrl == null) {
      handleReset();
    }
  }, [downloadUrl]);

  if (downloadUrl == null) return null;

  return <Image src={downloadUrl} alt="ダウンロード画像" loading="lazy" />;
};
